import React from 'react';
import { X, Tag } from '@phosphor-icons/react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const VEHICLE_TYPES = [
  { value: 'utilitaire', label: 'Utilitaire' },
  { value: 'tourisme', label: 'Tourisme' }
];
const CONDITIONS = [
  { value: 'neuf', label: 'Neuf' },
  { value: 'bon', label: 'Bon etat' },
  { value: 'usage', label: 'Usage' },
  { value: 'reparation', label: 'En reparation' },
  { value: 'hors_service', label: 'Hors service' }
];
const EXPENSE_CATS = ['pneu', 'reparation', 'entretien', 'carburant', 'assurance', 'controle_technique', 'stationnement', 'peage', 'autre'];
const DOC_CATS = ['carte_grise', 'attestation_assurance', 'contrat_assurance', 'controle_technique', 'facture', 'autre'];

export const VehicleFormModal = ({ editVehicle, form, setForm, onClose, onSubmit, employees = [] }) => (
  <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
    <div style={{ backgroundColor: 'white', borderRadius: '4px', width: '100%', maxWidth: '640px', maxHeight: '90vh', overflow: 'auto' }}>
      <div style={{ padding: '20px 24px', borderBottom: '1px solid #E2E2E6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>{editVehicle ? 'Modifier le vehicule' : 'Ajouter un vehicule'}</h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={24} /></button>
      </div>
      <form onSubmit={onSubmit} style={{ padding: '24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
          <div className="form-group">
            <label className="form-label">Marque *</label>
            <input type="text" className="form-input" value={form.brand} onChange={(e) => setForm({...form, brand: e.target.value})} required />
          </div>
          <div className="form-group">
            <label className="form-label">Modele *</label>
            <input type="text" className="form-input" value={form.model} onChange={(e) => setForm({...form, model: e.target.value})} required />
          </div>
          <div className="form-group">
            <label className="form-label">Type</label>
            <Select value={form.vehicle_type} onValueChange={(v) => setForm({...form, vehicle_type: v})}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                {VEHICLE_TYPES.map(t => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div className="form-group">
            <label className="form-label">Immatriculation</label>
            <input type="text" className="form-input" value={form.registration} onChange={(e) => setForm({...form, registration: e.target.value})} placeholder="AB-123-CD" />
          </div>
          <div className="form-group">
            <label className="form-label">Etat</label>
            <Select value={form.condition} onValueChange={(v) => setForm({...form, condition: v})}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                {CONDITIONS.map(c => <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div className="form-group">
            <label className="form-label">Date d'achat</label>
            <input type="date" className="form-input" value={form.purchase_date} onChange={(e) => setForm({...form, purchase_date: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">Prix d'achat (euro)</label>
            <input type="number" step="0.01" className="form-input" value={form.purchase_price} onChange={(e) => setForm({...form, purchase_price: e.target.value})} />
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div className="form-group">
            <label className="form-label">Assurance du</label>
            <input type="date" className="form-input" value={form.insurance_start} onChange={(e) => setForm({...form, insurance_start: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">Assurance au</label>
            <input type="date" className="form-input" value={form.insurance_end} onChange={(e) => setForm({...form, insurance_end: e.target.value})} />
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Date controle technique</label>
          <input type="date" className="form-input" value={form.technical_control_date} onChange={(e) => setForm({...form, technical_control_date: e.target.value})} />
        </div>
        <div className="form-group">
          <label className="form-label">Affecter a un salarie (optionnel)</label>
          <Select value={form.assigned_user_id || 'none'} onValueChange={(v) => setForm({ ...form, assigned_user_id: v === 'none' ? '' : v })}>
            <SelectTrigger data-testid="vehicle-assign-select"><SelectValue placeholder="Aucun" /></SelectTrigger>
            <SelectContent className="z-[9999]">
              <SelectItem value="none">Aucun (non affecte)</SelectItem>
              {employees.map(emp => (
                <SelectItem key={emp.id} value={emp.id}>{emp.name}{emp.email ? ` - ${emp.email}` : ''}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <small style={{ color: '#5E5F66', fontSize: '0.75rem' }}>
            Le salarie affecte pourra consulter les documents du vehicule depuis son application.
          </small>
        </div>
        <div className="form-group">
          <label className="form-label">Notes</label>
          <textarea className="form-input" value={form.notes} onChange={(e) => setForm({...form, notes: e.target.value})} rows={2} />
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
          <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Annuler</button>
          <button type="submit" className="btn btn-primary" style={{ flex: 1 }} data-testid="vehicle-submit">{editVehicle ? 'Enregistrer' : 'Ajouter'}</button>
        </div>
      </form>
    </div>
  </div>
);

export const VehicleExpenseModal = ({ expenseForm, setExpenseForm, onClose, onSubmit }) => (
  <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
    <div style={{ backgroundColor: 'white', borderRadius: '4px', width: '100%', maxWidth: '480px' }}>
      <div style={{ padding: '20px 24px', borderBottom: '1px solid #E2E2E6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Ajouter une depense vehicule</h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={24} /></button>
      </div>
      <form onSubmit={onSubmit} style={{ padding: '24px' }}>
        <div className="form-group">
          <label className="form-label">Categorie</label>
          <Select value={expenseForm.category} onValueChange={(v) => setExpenseForm({...expenseForm, category: v})}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              {EXPENSE_CATS.map(c => <SelectItem key={c} value={c}>{c.charAt(0).toUpperCase() + c.slice(1).replace('_', ' ')}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="form-group">
          <label className="form-label">Description *</label>
          <input type="text" className="form-input" value={expenseForm.description} onChange={(e) => setExpenseForm({...expenseForm, description: e.target.value})} required />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
          <div className="form-group">
            <label className="form-label">Montant HT *</label>
            <input type="number" step="0.01" className="form-input" value={expenseForm.amount_ht} onChange={(e) => setExpenseForm({...expenseForm, amount_ht: e.target.value})} required />
          </div>
          <div className="form-group">
            <label className="form-label">TVA %</label>
            <input type="number" step="0.1" className="form-input" value={expenseForm.tva_rate} onChange={(e) => setExpenseForm({...expenseForm, tva_rate: parseFloat(e.target.value) || 20})} />
          </div>
          <div className="form-group">
            <label className="form-label">Date *</label>
            <input type="date" className="form-input" value={expenseForm.date} onChange={(e) => setExpenseForm({...expenseForm, date: e.target.value})} required />
          </div>
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
          <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Annuler</button>
          <button type="submit" className="btn btn-primary" style={{ flex: 1 }}>Ajouter</button>
        </div>
      </form>
    </div>
  </div>
);

export const VehicleDocModal = ({ docForm, setDocForm, onClose, onSubmit }) => (
  <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
    <div style={{ backgroundColor: 'white', borderRadius: '4px', width: '100%', maxWidth: '480px' }}>
      <div style={{ padding: '20px 24px', borderBottom: '1px solid #E2E2E6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Ajouter un document</h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={24} /></button>
      </div>
      <form onSubmit={onSubmit} style={{ padding: '24px' }}>
        <div className="form-group">
          <label className="form-label">Titre</label>
          <input type="text" className="form-input" value={docForm.title} onChange={(e) => setDocForm({...docForm, title: e.target.value})} placeholder="Ex: Carte grise" />
        </div>
        <div className="form-group">
          <label className="form-label">Categorie</label>
          <Select value={docForm.category} onValueChange={(v) => setDocForm({...docForm, category: v})}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              {DOC_CATS.map(c => <SelectItem key={c} value={c}>{c.replace(/_/g, ' ').replace(/^\w/, l => l.toUpperCase())}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="form-group">
          <label className="form-label">Fichier *</label>
          <input type="file" className="form-input" onChange={(e) => setDocForm({...docForm, file: e.target.files[0]})} required />
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
          <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Annuler</button>
          <button type="submit" className="btn btn-primary" style={{ flex: 1 }}>Ajouter</button>
        </div>
      </form>
    </div>
  </div>
);

export const VehicleSellModal = ({ sellForm, setSellForm, onClose, onSubmit }) => (
  <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
    <div style={{ backgroundColor: 'white', borderRadius: '4px', width: '100%', maxWidth: '400px' }}>
      <div style={{ padding: '20px 24px', borderBottom: '1px solid #E2E2E6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Vendre le vehicule</h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={24} /></button>
      </div>
      <form onSubmit={onSubmit} style={{ padding: '24px' }}>
        <div className="form-group">
          <label className="form-label">Date de sortie *</label>
          <input type="date" className="form-input" value={sellForm.sold_date} onChange={(e) => setSellForm({...sellForm, sold_date: e.target.value})} required />
        </div>
        <div className="form-group">
          <label className="form-label">Prix de vente (euro)</label>
          <input type="number" step="0.01" className="form-input" value={sellForm.sold_price} onChange={(e) => setSellForm({...sellForm, sold_price: e.target.value})} />
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
          <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Annuler</button>
          <button type="submit" className="btn btn-primary" style={{ flex: 1 }}>Confirmer la vente</button>
        </div>
      </form>
    </div>
  </div>
);
